import {Response} from 'ts-retrofit';

// Backward-compatible: open the blob in a new tab/window
export async function downloadFile(getPromise: Promise<Response<Blob>>) {
  const response = await getPromise;
  const temporaryUrl = window.URL.createObjectURL(response.data);
  window.open(temporaryUrl, '_blank');
}

// New: force download as attachment, try to extract filename from headers
export async function downloadAttachment(getPromise: Promise<Response<Blob>>, fallbackFileName: string = 'download') {
  const response = await getPromise;
  const blob = response.data;

  let fileName = fallbackFileName;
  try {
    // headers may be a plain object with lowercase keys
    // @ts-ignore
    const disposition: string | undefined = response.headers?.['content-disposition'] || response.headers?.['Content-Disposition'];
    if (disposition) {
      const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition);
      const encoded = match && (match[1] || match[2]);
      if (encoded) {
        fileName = decodeURIComponent(encoded);
      }
    }
  } catch (_) {
    // ignore header parsing errors and use fallback
  }

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
